import { render, staticRenderFns } from "./WechatConfigMessageModal.vue?vue&type=template&id=06201ad4&scoped=true"
import script from "./WechatConfigMessageModal.vue?vue&type=script&lang=js"
export * from "./WechatConfigMessageModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06201ad4",
  null
  
)

export default component.exports